import { useClassContext } from '../../../../Context';
import { getLatestFailure } from './helpers';

const useAttendanceInProgressNotification = () => {
  const { cls } = useClassContext();

  const attendanceInProgress = cls?.attendanceInProgress;

  const latestFailure = getLatestFailure(attendanceInProgress);

  return { latestFailure };
};

export default useAttendanceInProgressNotification;
